import _toConsumableArray from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/toConsumableArray";
import _asyncToGenerator from "D:/progect/guowai/ex_express_web/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.map.js";
import "regenerator-runtime/runtime.js";
import form from '@/mixins/crud-form';
import utils from '@/utils';
export default {
  mixins: [form],
  data: function data() {
    return {
      api: {
        detail: 'DEVICE_DETAIL',
        create: 'DEVICE_CREATE',
        update: 'DEVICE_UPDATE'
      },
      dialog: {
        width: '900px',
        height: '900px'
      },
      userInfo: {},
      dictPaypal: []
    };
  },
  created: function created() {
    var _this = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return _this.$store.dispatch('d2admin/db/get', {
                dbName: 'sys',
                path: 'user.info',
                defaultValue: {},
                user: true
              }, {
                root: true
              });

            case 2:
              _this.userInfo = _context.sent;

            case 3:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  computed: {
    setting: function setting() {
      var _this2 = this;

      var h = this.$createElement;
      // console.log(this.form,"000000000000000000")
      return [].concat(_toConsumableArray(this.userInfo.market_id > 0 ? [] : [{
        prop: 'market_id',
        default: '',
        label: this.$t('market_id'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_market_id",
              "clearable": true,
              "custom": true
            },
            "model": {
              value: _this2.form.model.market_id,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "market_id", $$v);
              }
            }
          });
        }
      }]), [{
        prop: 'market_mobile',
        default: this.market_mobile ? this.market_mobile : utils.cookies.get('phone'),
        label: this.$t('market_mobile'),
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "disabled": true
            },
            "model": {
              value: _this2.form.model.market_mobile,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "market_mobile", $$v);
              }
            }
          });
        }
      }, {
        prop: 'charge_id',
        default: null,
        label: this.$t('charge'),
        col: {
          span: 8
        },
        render: function render() {
          return h("d2-dict-select", {
            "attrs": {
              "name": "form_charge_id",
              "custom": true,
              "stringify": true
            },
            "model": {
              value: _this2.form.model.charge_id,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "charge_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_name',
        default: '',
        label: this.$t('device_name'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.device_name,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "device_name", $$v);
              }
            }
          });
        }
      }, {
        prop: 'help_phone',
        default: '',
        label: this.$t('help_phone'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.help_phone,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "help_phone", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_number',
        default: '',
        label: this.$t('device_number'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.device_number,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "device_number", $$v);
              }
            }
          });
        }
      }], _toConsumableArray(this.mode === 'edit' ? [] : [{
        prop: 'uq_key',
        default: '',
        label: 'ukey',
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "on": {
              "input": function input(value) {
                return _this2.form.model.uq_key = value.replace(/\s+/g, '');
              }
            },
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.uq_key,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "uq_key", $$v);
              }
            }
          });
        }
      }]), [
      /* {
        prop: 'ukey',
        default: '',
        label: 'ukey',
        col: { span: 8 },
        rule: { required: true, message: 'required', trigger: 'change' },
        render: () => <el-input vModel={ this.form.model.ukey } clearable/>
      }, */
      // {
      //   prop: 'map',
      //   default: '',
      //   label: '地图',
      //   col: { span: 16 },
      //   render: () => <d2-map name="form_map" vModel={ this.form.model } />
      // },
      {
        prop: 'province',
        default: '',
        label: this.$t('province'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.province,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "province", $$v);
              }
            }
          });
        }
      }, {
        prop: 'city',
        default: '',
        label: this.$t('city'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.city,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "city", $$v);
              }
            }
          });
        }
      }, {
        prop: 'district',
        default: '',
        label: this.$t('district'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.district,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "district", $$v);
              }
            }
          });
        }
      }, {
        prop: 'street',
        default: '',
        label: this.$t('street'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.street,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "street", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_address',
        default: '',
        label: this.$t('device_address'),
        col: {
          span: 24
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.device_address,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "device_address", $$v);
              }
            }
          });
        }
      }, {
        prop: 'longitude',
        default: '',
        label: this.$t('longitude'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.longitude,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "longitude", $$v);
              }
            }
          });
        }
      }, {
        prop: 'latitude',
        default: '',
        label: this.$t('latitude'),
        col: {
          span: 8
        },
        rule: {
          required: true,
          message: 'required',
          trigger: 'change'
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.latitude,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "latitude", $$v);
              }
            }
          });
        }
      }, {
        prop: 'device_type',
        default: '',
        label: this.$t('device_type'),
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.device_type,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "device_type", $$v);
              }
            }
          });
        }
      }], _toConsumableArray(this.mode !== 'edit' ? [] : [{
        prop: 'paypal',
        default: '',
        label: this.$t('类型'),
        col: {
          span: 8
        },
        render: function render() {
          //下拉选择
          return h("el-select", {
            "attrs": {
              "clearable": true
            },
            "on": {
              "change": function change(value) {
                _this2.changePaypal(value);
              }
            },
            "model": {
              value: _this2.form.model.paypal,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "paypal", $$v);
              }
            }
          }, [_this2.dictPaypal.map(function (item) {
            return h("el-option", {
              "key": item.paypal_id,
              "attrs": {
                "label": item.type,
                "value": item.type
              }
            });
          })]);
        }
      }, {
        prop: 'paypal_currency_code',
        default: '',
        label: this.$t('货币类型'),
        col: {
          span: 16
        },
        render: function render() {
          return h("span", {
            "style": {}
          }, [h("el-input", {
            "style": {
              flex: 1
            },
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.paypal_currency_code,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "paypal_currency_code", $$v);
              }
            }
          }), h("a", {
            "attrs": {
              "href": 'https://developer.paypal.com/api/rest/reference/currency-codes/',
              "target": '_blank'
            }
          }, [_this2.$t('参考')])]);
        }
      }, {
        prop: 'paypal_id',
        default: '',
        label: this.$t('Paypal ID'),
        col: {
          span: 16
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.paypal_id,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "paypal_id", $$v);
              }
            }
          });
        }
      }, {
        prop: 'paypal_api_host',
        default: '',
        label: this.$t('Paypal Api Host'),
        col: {
          span: 8
        },
        render: function render() {
          return h("el-input", {
            "attrs": {
              "clearable": true
            },
            "model": {
              value: _this2.form.model.paypal_api_host,
              callback: function callback($$v) {
                _this2.$set(_this2.form.model, "paypal_api_host", $$v);
              }
            }
          });
        }
      }]));
    },
    // [本页面特有] 父级字典项目的 id 强制转为数字
    market_mobile: function market_mobile() {
      return this.$route.query.market_mobile;
    }
  },
  methods: {
    /**
         * @description 加载需要的字典数据
         */
    loadDict: function loadDict() {
      // 衣物类型
      this.loadDictOne({
        name: 'form_market_id',
        method: this.$api.MARKET_ALL,
        fields: 'id,user_name',
        path: 'list',
        label: 'user_name',
        value: 'id'
      });
      this.loadDictOne({
        name: 'form_charge_id',
        method: this.$api.CHARGE_CONFIGS_ALL,
        fields: 'id,charge_name',
        path: 'list',
        label: 'charge_name',
        value: 'id'
      }); // console.log("加载字典");
      //获取本地存入的值

      var arrobg = [{
        type: "debug",
        paypal_id: "",
        paypal_api_host: "",
        paypal_currency_code: ""
      }, {
        type: "release",
        paypal_id: "",
        paypal_api_host: "",
        paypal_currency_code: ""
      }];
      var a = utils.db.dbGet({
        dbName: "database",
        path: "paypal",
        defaultValue: arrobg,
        user: true
      });
      this.dictPaypal = a; // console.log("获取字典",a);
      // dbSet ({
      //   dbName = 'database',
      //   path = '',
      //   value = '',
      //   user = false
      // })
    },
    changePaypal: function changePaypal(val) {
      // console.log(val)
      //得到对应的值，赋值给form
      for (var i = 0; i < this.dictPaypal.length; i++) {
        if (this.dictPaypal[i].type == val) {
          this.form.model.paypal_id = this.dictPaypal[i].paypal_id;
          this.form.model.paypal_api_host = this.dictPaypal[i].paypal_api_host;
          this.form.model.paypal_currency_code = this.dictPaypal[i].paypal_currency_code;
        }
      }
    },
    transformSubmitData: function transformSubmitData(data) {
      // console.log("提交处理",data)
      var paypal = data.paypal;

      for (var i = 0; i < this.dictPaypal.length; i++) {
        if (this.dictPaypal[i].type == paypal) {
          this.dictPaypal[i].paypal_id = data.paypal_id;
          this.dictPaypal[i].paypal_api_host = data.paypal_api_host;
          this.dictPaypal[i].paypal_currency_code = data.paypal_currency_code;
        }
      }

      utils.db.dbSet({
        dbName: 'database',
        path: 'paypal',
        value: this.dictPaypal,
        user: true
      });
      return data;
    }
  }
};